import React, { useState, useEffect } from "react";
import {
  Container,
  Box,
  Paper,
  styled,
  CircularProgress,
  Button,
  Select, // Added for dropdown
  MenuItem, // Added for dropdown
  FormControl, // Added for dropdown
  InputLabel, // Added for dropdown
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import HeaderStatsCard from "../../components/customcard/HeaderStatsCard";
import Analytics from "../../components/customChart/Analatics";
import ExamCenterDetailsTable from "../../components/CustomTable/ExamCenterDetailsTable";
import FilterComponent from "../../components/CustomTable/FilterComponent";
import StudentDetailsTable from "../../components/CustomTable/StudentInfo";
import PieChart from "../../components/pieChart/PieChart";
import { getStudentCount } from "../../services/admin.services";
import ExamDetailsColumns from "../../data/ExamDetailsColumn";
import api from "../../services/apiUtility";

const AdminDashboard = ({ analytics }) => {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [centerCode, setCenterCode] = useState("");
  const [shiftTime, setShiftTime] = useState("");
  const [examName, setExamName] = useState("");
  const [isExamDetais, setIsExamDetails] = useState(true);
  const [isExamCenterDetails, setIsExamCenterDetails] = useState(false);
  const [examCenterStudentInfo, setExamCenterStudentInfo] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // --- NEW STATE FOR TOTAL SHIFTS ---
  const [totalShifts, setTotalShifts] = useState(0);

  const [syncing, setSyncing] = useState(false);
  const [examStatsData, setExamStatsData] = useState({});
  const [analyticKeys, setAnalyticKeys] = useState([]);
  const [analyticValues, setAnalyticValues] = useState();
  const [selectedValue, setSelectedValue] = useState("All");
  const [centerStats, setCenterStats] = useState({
    enrollmentStartedCount: 0,
    totalCenters: 0,
  });
  const [selectedEnrollment, setSelectedEnrollment] = useState("all");
  const [selectedAttendance, setSelectedAttendance] = useState("all");
  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("All");

  const userRole = localStorage.getItem("userRole");
  const isAdmin = userRole === "admin";

  const fetchExamData = async (currentExamName, currentShift) => {
    try {
      const eName = currentExamName || examName;
      const sTime = currentShift || shiftTime;

      if (!eName || !sTime) return;

      const response = await getStudentCount(eName, sTime);
      console.log("AdminDashboard API Response:", response.data);
      if (response.status === 200) {
        const centerSummaries = response.data.map((item, index) => {
          const percentage =
            item.totalStudents > 0
              ? ((item.presentStudents / item.totalStudents) * 100).toFixed(2)
              : "0.00";

          return {
            sNo: index + 1,
            centerCode: item.centerCode,
            centerName: item.centerName,
            shiftDate: item.shiftDate,
            shiftTime: item.shiftTime,
            totalStudents: item.total_candidates || item.totalStudents || 0,
            attendedStudents: item.attended_count || item.attendedStudents || 0,
            presentStudents: item.present_count || item.presentStudents || 0,
            apiSyncCount: item.apiSyncCount || item.sync_count || 0,
            examCity: item.exam_city || item.examCity,
            centerStatus: item.any_mismatched ?? item.anyMismatched ?? (item.present_count !== item.attended_count),
            attendancePercentage: `${percentage}%`,
          };
        });

        const uniqueCities = [
          ...new Set(centerSummaries.map((center) => center.examCity).filter(Boolean)),
        ];
        setCities(["All", ...uniqueCities]);
        setRows(centerSummaries);
        
        const allCenters = centerSummaries.map((center) => ({
          centerName: center.centerName,
          centerCode: center.centerCode,
        }));
        localStorage.setItem("allCenters", JSON.stringify(allCenters));

        const totalAttendedStudents = centerSummaries.reduce(
          (acc, item) => acc + (item.attendedStudents || 0),
          0
        );

        const totalCandidates = centerSummaries.reduce(
          (acc, item) => acc + (item.totalStudents || 0),
          0
        );
        const presentStudents = centerSummaries.reduce(
          (acc, item) => acc + (item.presentStudents || 0),
          0
        );
        const absentStudent = totalCandidates - presentStudents;

        setExamStatsData({
          totalCandidates,
          presentStudents,
          absentStudent,
          totalAttendedStudents,
          presetPercentage:
            totalCandidates > 0
              ? ((presentStudents / totalCandidates) * 100).toFixed(2)
              : "0.00",
          absentPercentage:
            totalCandidates > 0
              ? ((absentStudent / totalCandidates) * 100).toFixed(2)
              : "0.00",
        });

        const totalCenters = centerSummaries.length;
        const enrollmentStartedCount = centerSummaries.filter(
          (center) => center.presentStudents > 0
        ).length;

        setCenterStats({
          enrollmentStartedCount,
          totalCenters,
        });
      }
    } catch (error) {
      console.error("Error fetching exam data:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchStudentDetails = async () => {
    try {
      setLoading(true);
      const url = `https://croireatpl.in/api/students/${examName}/${centerCode}/${shiftTime}`;
      const response = await fetch(url);
      const data = await response.json();
      if (response.ok) {
        setExamCenterStudentInfo(data);
        setIsExamDetails(false);
        setIsExamCenterDetails(true);
      }
    } catch (error) {
      console.error("Error fetching student details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAutoEnrollSync = async () => {
    if (!examName || !shiftTime) {
      alert("Exam Name and Shift are required to sync.");
      return;
    }
    try {
      setSyncing(true);
      const url = `https://croireatpl.in/api/auto-enroll-students?examName=${examName}&shift=${shiftTime}`;
      const response = await fetch(url);
      if (response.ok) {
        await fetchExamData(examName, shiftTime);
      } else {
        alert("Failed to sync auto-enrollment data.");
      }
    } catch (error) {
      console.error("Error syncing auto-enroll data:", error);
      alert("An error occurred while syncing.");
    } finally {
      setSyncing(false);
    }
  };

  // --- NEW HANDLER FOR SHIFT DROPDOWN ---
  // --- UPDATED HANDLER FOR SHIFT DROPDOWN ---
  const handleShiftChange = (event) => {
    const selectedShift = event.target.value;
    
    // 1. Update the React state to reflect change in UI
    setShiftTime(selectedShift);

    // 2. Retrieve the current object from localStorage
    const storedExamDetails = localStorage.getItem("examDetails");
    
    if (storedExamDetails) {
      const examDetails = JSON.parse(storedExamDetails);
      
      // 3. Create an updated object with the new shift
      const updatedDetails = {
        ...examDetails,
        shift: selectedShift,
      };

      // 4. Save the updated object back to localStorage
      localStorage.setItem("examDetails", JSON.stringify(updatedDetails));
    }

    // 5. Fetch data immediately for the new shift
    // We pass selectedShift directly because setShiftTime is asynchronous
    fetchExamData(examName, selectedShift);
  };

  useEffect(() => {
    let filteredData = rows;
    if (selectedCity && selectedCity !== "All") {
      filteredData = filteredData.filter((row) => row.examCity === selectedCity);
    }
    if (selectedEnrollment === "started") {
      filteredData = filteredData.filter((row) => row.presentStudents > 0);
    } else if (selectedEnrollment === "not_started") {
      filteredData = filteredData.filter((row) => row.presentStudents === 0);
    }
    if (selectedAttendance === "started") {
      filteredData = filteredData.filter((row) => row.attendedStudents > 0);
    } else if (selectedAttendance === "not_started") {
      filteredData = filteredData.filter((row) => !(row.attendedStudents > 0));
    }
    setFilteredRows(filteredData);
  }, [rows, selectedCity, selectedEnrollment, selectedAttendance]);

  useEffect(() => {
    const examDetails = JSON.parse(localStorage.getItem("examDetails"));
    if (examDetails) {
      const { examName, shift, totalShifts } = examDetails;
      setExamName(examName);
      setShiftTime(shift);
      setTotalShifts(totalShifts || 0); // Set total shifts from login data
      fetchExamData(examName, shift);
    }
  }, []);

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    if (centerCode === "all") {
      const examDetails = JSON.parse(localStorage.getItem("examDetails"));
      if (examDetails) {
        const { examName, shift } = examDetails;
        setExamName(examName);
        setShiftTime(shift);
        fetchExamData(examName, shift);
      }
      setIsExamDetails(true);
      setIsExamCenterDetails(false);
    } else if (centerCode && shiftTime && examName) {
      fetchStudentDetails();
    } else {
      alert("Please select all filters to fetch data.");
    }
  };

  const candidateStats = [
    { label: "Present", count: examStatsData?.presentStudents, percentage: 90 },
    { label: "Absent", count: examStatsData?.absentStudent, percentage: 10 },
  ];

  if (loading) {
    return (
      <Container sx={{ mt: 4, display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
        <CircularProgress size={60} />
      </Container>
    );
  }

  if (analytics) return <Analytics data={candidateStats} />;

  return (
    <Box sx={{ m: 4 }}>
      
      {/* --- UPDATED REFRESH & SHIFT DROPDOWN SECTION --- */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mb: 2, gap: 2 }}>
        
        {totalShifts > 0 && (
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel id="shift-select-label">Shift</InputLabel>
            <Select
              labelId="shift-select-label"
              value={shiftTime}
              label="Shift"
              onChange={handleShiftChange}
            >
              {[...Array(totalShifts)].map((_, index) => (
                <MenuItem key={index + 1} value={(index + 1).toString()}>
                  Shift {index + 1}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

        <Button
          variant="contained"
          color="primary"
          sx={{ height: "40px" }} // Align height with Select
          startIcon={syncing ? <CircularProgress size={20} color="inherit" /> : <RefreshIcon />}
          onClick={handleAutoEnrollSync}
          disabled={syncing || !examName || !shiftTime}
        >
          {syncing ? "Syncing..." : "Refresh Data"}
        </Button>
      </Box>

      {/* --- REST OF THE UI REMAINS UNCHANGED --- */}
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3, alignItems: "stretch" }}>
        <Box sx={{ flex: "1 1 280px", minWidth: "280px" }}>
          <HeaderStatsCard
            title="Enrollment Started"
            count={centerStats.enrollmentStartedCount}
            total={centerStats.totalCenters}
            subtitle="Centres"
            backgroundColor="white"
            numberColor="black"
          />
        </Box>

        <Box sx={{ flex: "1 1 280px", minWidth: "280px" }}>
          <HeaderStatsCard
            title="Attendance"
            count={examStatsData?.totalAttendedStudents || 0}
            total={examStatsData?.totalCandidates || 0}
            subtitle="Candidates"
            backgroundColor="white"
            numberColor="black"
          />
        </Box>

        <Box sx={{ flex: "1 1 280px", minWidth: "280px" }}>
          <HeaderStatsCard
            title="Sync Status"
            count={examStatsData?.presentStudents || 0}
            total={examStatsData?.totalCandidates || 0}
            subtitle="Present"
            backgroundColor="white"
            numberColor="black"
          />
        </Box>

        <Box sx={{ flex: "1 1 280px", minWidth: "280px" }}>
          <Box sx={{ border: "1px solid #e5e5e5", borderRadius: 2, boxShadow: 2, height: "100%", pb: 5 }}>
            <PieChart
              presetPercentage={examStatsData?.presetPercentage}
              absentPercentage={examStatsData?.absentPercentage}
              totalCandidates={examStatsData?.totalCandidates}
            />
          </Box>
        </Box>
      </Box>

      <FilterComponent
        centerCode={centerCode}
        setCenterCode={setCenterCode}
        shiftTime={shiftTime}
        setShiftTime={setShiftTime}
        examName={examName}
        setExamName={setExamName}
        handleFilterSubmit={handleFilterSubmit}
        rows={rows}
      />

      {isExamDetais && (
        <ExamCenterDetailsTable
          rows={filteredRows}
          columns={ExamDetailsColumns}
          
          cities={cities}
          selectedCity={selectedCity}
          setSelectedCity={setSelectedCity}
          loading={loading}
          isAdmin={isAdmin}
          selectedEnrollment={selectedEnrollment}
          setSelectedEnrollment={setSelectedEnrollment}
          selectedAttendance={selectedAttendance}
          setSelectedAttendance={setSelectedAttendance}
        />
      )}

      {isExamCenterDetails && (
        <StudentDetailsTable
          studentData={examCenterStudentInfo}
          loading={loading}
          isAdmin={isAdmin}
        />
      )}
    </Box>
  );
};

export default AdminDashboard;